import type { Catalog } from "../en";

/** Filipino: Dashboard screen (mirrors en/dashboard.ts). */
export const dashboard: Catalog["dashboard"] = {
  title: "Dashboard",
  greeting: {
    morning: "Magandang umaga, {{name}}",
    afternoon: "Magandang hapon, {{name}}",
    evening: "Magandang gabi, {{name}}",
  },
  subtitleAgentLead: "Narito kung paano gumana ang",
  subtitleAgentTail: "{{period}}.",
  subtitleAll: "Narito kung paano gumana ang inyong mga assistant {{period}}.",
  period: {
    "7d": "ngayong linggo",
    "30d": "sa nakaraang 30 araw",
    "90d": "sa nakaraang 90 araw",
  },
  range: {
    label: "Panahon",
  },
  vsPrevious: {
    "7d": "kumpara noong nakaraang linggo",
    "30d": "kumpara sa naunang 30 araw",
    "90d": "kumpara sa naunang 90 araw",
  },
  testInPlayground: "Subukan sa Playground",
  shareLink: "Ibahagi ang chat link",
  loadError: "Hindi ma-load ang dashboard.",
  loadErrorBody: "Ligtas ang inyong data. Suriin ang koneksyon at subukan muli.",
  checklist: {
    title: "Tapusin ang pag-setup ng inyong assistant",
    progress: "Setup {{done}} sa {{total}}",
    progressLabel: "Progreso ng setup",
    dismiss: "Isara ang setup checklist",
    dismissed: "Nakatago na ang setup checklist. Makikita ninyo ang mga hakbang sa bawat seksyon.",
    steps: {
      create_agent: "Gumawa ng inyong assistant",
      add_knowledge: "Idagdag ang inyong mga dokumento",
      test_agent: "Subukan sa playground",
      install_channel: "I-install sa inyong website",
      invite_team: "Imbitahan ang inyong team",
      go_live: "Mag-live na",
    },
    done: "Tapos na",
  },
  kpi: {
    conversations: "Mga usapan",
    resolution: "Antas ng resolusyon ng AI",
    firstResponse: "Unang tugon",
    handedToStaff: "Ipinasa sa staff",
    leads: "Mga nakuhang lead",
    satisfaction: "Kasiyahan",
    p95: "p95 {{value}}",
    ratings_one: "mula sa {{count}} rating",
    ratings_other: "mula sa {{count}} rating",
    noRatings: "Wala pang rating",
    pts: "{{value}} pts",
    noComparison: "Walang naunang data na maikukumpara",
    seconds: "{{value}}s",
    outOf: "/5",
  },
  chart: {
    title: "Mga usapan bawat araw",
    range: "{{start}} – {{end}} · lahat ng channel",
    resolvedByAi: "Nalutas ng AI",
    handedToStaff: "Ipinasa sa staff",
    emptyTitle: "Walang usapan sa panahong ito",
    emptyBody: "Kapag nagsimulang mag-chat ang mga bisita, makikita ninyo rito ang dami bawat araw.",
  },
  topics: {
    title: "Ano ang madalas itanong",
    details: "Mga detalye",
    emptyTitle: "Lalabas ang mga paksa pagkatapos ng ilang usapan",
    emptyBody: "Pinapangkat namin ang mga tanong ayon sa paksa para makita ninyo ang pinakamahalaga.",
    languages: "Mga wika",
    languageNames: {
      en: "English",
      fil: "Filipino",
      tl: "Filipino",
      taglish: "Taglish",
      ceb: "Cebuano",
      pam: "Kapampangan",
      other: "Iba pa",
    },
    share: "{{label}}: {{pct}}",
  },
  recent: {
    title: "Mga kamakailang usapan",
    openInbox: "Buksan ang inbox",
    colVisitor: "Bisita",
    colChannel: "Channel",
    colQuestion: "Unang tanong",
    colStatus: "Status",
    colWhen: "Kailan",
    noQuestion: "Wala pang tanong",
    emptyTitle: "Wala pang usapan",
    emptyBody: "Ibahagi ang inyong chat link o i-install ang widget para magsimulang sumagot.",
    status: {
      resolved: "Nalutas",
      needs_staff: "Kailangan ng staff",
      lead_captured: "Nakuha ang lead",
      open: "Bukas",
      closed: "Sarado",
    },
  },
  channels: {
    widget: "Widget",
    webapp: "Web app",
    mobile: "Mobile app",
    messenger: "Messenger",
    email: "Email",
    api: "API",
    playground: "Playground",
  },
  gaps: {
    title: "Pangunahing kakulangan sa kaalaman",
    seeAll: "Tingnan lahat ({{count}})",
    asked_one: "Itinanong nang {{count}} beses",
    asked_other: "Itinanong nang {{count}} beses",
    answer: "Sagutin",
    answerLabel: "Sagutin: {{question}}",
    reasons: {
      no_source: "walang nahanap na source",
      low_confidence: "mababa ang kumpiyansa",
      outdated_source: "luma na ang source",
      conflicting_sources: "magkasalungat na source",
    },
    emptyTitle: "Walang bukas na kakulangan",
    emptyBody: "May nahanap na sagot ang inyong assistant sa bawat tanong.",
  },
  knowledge: {
    title: "Kalusugan ng knowledge base",
    manage: "Pamahalaan",
    sources: "Mga source",
    chunks: "Mga chunk",
    lastSync: "Huling sync",
    never: "Hindi pa",
    flaggedBody: "kailangang tingnan: {{reason}}",
    flaggedFallback: "suriin ang source na ito para sa mas mahusay na sagot.",
    emptyTitle: "Wala pang dokumento",
    emptyBody: "Idagdag ang inyong mga dokumento para makasagot ang assistant mula rito.",
    addSources: "Magdagdag ng source",
  },
  share: {
    title: "Ibahagi ang inyong assistant",
    description: "Kahit sino na may link na ito ay makaka-chat kay {{agent}}.",
    urlLabel: "Pampublikong chat link",
    copy: "Kopyahin ang link",
    copied: "Nakopya ang link",
    copyFailed: "Hindi makopya. Piliin ang link at kopyahin nang manu-mano.",
    customDomain: "Na-verify ang custom domain. Makaka-chat ang mga bisita nang hindi nagsa-sign in; makikita ng mga naka-sign in na audience ang kanilang pribadong sagot.",
    defaultDomain: "Makaka-chat ang mga bisita nang hindi nagsa-sign in. Idagdag ang sarili ninyong domain sa Settings → Domains.",
    openWebApp: "Buksan ang web app",
    previewWidget: "I-preview ang widget",
    unavailableTitle: "Hindi pa naka-on ang web app",
    unavailableBody: "I-on ang web app channel para makakuha ng maibabahaging chat link.",
    openChannels: "Buksan ang Channels",
    loadError: "Hindi ma-load ang chat link.",
  },
  noAgentsTitle: "Gumawa ng inyong unang assistant",
  noAgentsBody: "Mapupuno ang inyong dashboard kapag nagsimulang sumagot ang isang assistant.",
  createAgent: "Gumawa ng assistant",
};
